const ListItemUuidCopy = () => import('@/components/Engine/ListItemUuidCopy')
const FixedPricesListItemType = () => import(/* webpackChunkName: "quotes" */ '@/components/FixedPrices/ListItemType')
const FixedPricesListItemOwner = () => import(/* webpackChunkName: "quotes" */ '@/components/FixedPrices/ListItemOwner')
const FixedPricesListItemDate = () => import(/* webpackChunkName: "quotes" */ '@/components/FixedPrices/ListItemDate')
const FixedPricesListItemAmount = () => import(/* webpackChunkName: "quotes" */ '@/components/FixedPrices/ListItemAmount')
const FixedPricesListItemStatus = () => import(/* webpackChunkName: "quotes" */ '@/components/FixedPrices/ListItemStatus')
const FixedPricesListItemProcessedData = () => import(/* webpackChunkName: "quotes" */ '@/components/FixedPrices/ListItemProcessedData')
const FixedPricesListItemResult = () => import(/* webpackChunkName: "quotes" */ '@/components/FixedPrices/ListItemResult')
const FixedPricesListActions = () => import(/* webpackChunkName: "quotes" */ '@/components/FixedPrices/ListActions')

const fixedPricesModel = vm => ({
  title: vm.$gettext('Fixed Prices'),
  endpoint: 'fixed-amount-price-schedules',
  countrize: 'owner_country',
  fields: [
    {
      key: 'id',
      sortable: true,
      component: value => ({
        is: ListItemUuidCopy,
        props: { value }
      })
    },
    {
      key: 'type',
      label: vm.$gettext('Type'),
      sortable: true,
      component: (value, key, item) => ({
        is: FixedPricesListItemType,
        props: { value, item }
      })
    },
    {
      key: 'model_id',
      sortable: true,
      label: vm.$gettext('Owner'),
      component: (value, key, item) => ({
        is: FixedPricesListItemOwner,
        props: { item }
      })
    },
    {
      key: 'from_date',
      sortable: true,
      label: vm.$gettext('Start Date'),
      component: (value, key, item) => ({
        is: FixedPricesListItemDate,
        props: { value, item }
      })
    },
    {
      key: 'to_date',
      sortable: true,
      label: vm.$gettext('End Date'),
      component: (value, key, item) => ({
        is: FixedPricesListItemDate,
        props: { value, item }
      })
    },
    {
      key: 'amount',
      label: vm.$gettext('Amount'),
      component: (value, key, item) => ({
        is: FixedPricesListItemAmount,
        props: { item }
      })
    },
    {
      key: 'status',
      label: vm.$gettext('Status'),
      component: value => ({
        is: FixedPricesListItemStatus,
        props: { value }
      })
    },
    {
      key: 'proccessed_data',
      label: vm.$gettext('Proccessed Data'),
      hidden: true,
      component: (value, key, item) => ({
        is: FixedPricesListItemProcessedData,
        props: { item }
      })
    },
    {
      key: 'result',
      label: vm.$gettext('Result'),
      hidden: true,
      component: (value, key, item) => ({
        is: FixedPricesListItemResult,
        props: { item }
      })
    },
    {
      key: 'actions',
      label: vm.$gettext('Actions'),
      hidden: true,
      component: (value, key, item, row) => ({
        is: FixedPricesListActions,
        props: { row },
        on: {
          refresh: () => vm.$root.$emit('bv::refresh::table', 'apiListTable')
        }
      })
    }
  ],
  includes: [
    'fixed_tour.tour.courier.courier_available.tracking',
    'fixed_tour.tour.account_transactions',
    'owner'
  ],
  filters: []
})

export default fixedPricesModel
